import { css } from 'styled-components';

export const screenSizes = {
  smallMobile: 375,
  tablet: 768,
  desktop: 1024,
};

type mediaMixinType = 'min' | 'max';

const buildMediaMixin = (type: mediaMixinType, size: number) => (
  ...args
) => css`
  @media (${type}-width: ${size}px) {
    ${css(...args)};
  }
`;

const media = {
  tablet: buildMediaMixin('min', screenSizes.tablet),
  desktop: buildMediaMixin('min', screenSizes.desktop),
  smallMobile: buildMediaMixin('min', screenSizes.smallMobile),
  mobileOnly: buildMediaMixin('max', screenSizes.tablet - 1),
  tinyMobileOnly: buildMediaMixin('max', screenSizes.smallMobile - 1),
};

export default media;
